import axios from 'axios';
import qs from 'qs';
import { environment } from 'services/environment';

const apiClient = axios.create({
  baseURL: `${environment().url}/rest/preferences`,
  responseType: 'json',
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: (params) => qs.stringify(params),
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error.response?.data || error.message),
);

export default apiClient;

export const fullApiClient = axios.create({
  baseURL: `${environment().url}/rest/preferences`,
  responseType: 'json',
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: (params) => qs.stringify(params),
});
